import { ListEventsResponse } from '@fullstory/proto/fs/services/alexa';
import { combineReducers, createRequestReducer } from '@fullstory/redux-util';
import { SearchEventsTypes } from './types';

const capturedEvents = createRequestReducer<ListEventsResponse>()(
  SearchEventsTypes.ListEventsRequest,
  SearchEventsTypes.ListEventsSuccess,
  SearchEventsTypes.ListEventsFailure,
);

type SearchEventsReducerState = {
  capturedEvents: ReturnType<typeof capturedEvents>;
};

export const searchEventsReducer = combineReducers<SearchEventsReducerState>({
  capturedEvents,
});
